var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1368_2940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1.75C3.61725 1.75 0.875 4.49225 0.875 7.875C0.875 11.2577 3.61725 14 7 14C10.3827 14 13.125 11.2577 13.125 7.875C13.125 4.49225 10.3827 1.75 7 1.75ZM7 12.7969C4.28137 12.7969 2.07812 10.5936 2.07812 7.875C2.07812 5.15637 4.28137 2.95312 7 2.95312C9.71863 2.95312 11.9219 5.15637 11.9219 7.875C11.9219 10.5936 9.71863 12.7969 7 12.7969ZM12.7802 3.92613C12.9999 3.54288 13.125 3.09838 13.125 2.625C13.125 1.17513 11.9499 0 10.5 0C9.65475 0 8.90313 0.399875 8.42275 1.02025C10.2261 1.393 11.7749 2.45875 12.7802 3.927V3.92613ZM5.57725 1.02025C5.09688 0.399875 4.34525 0 3.5 0C2.05013 0 0.875 1.17513 0.875 2.625C0.875 3.09838 1.00013 3.54288 1.21975 3.92613C2.22425 2.45788 3.77387 1.39213 5.57725 1.01937V1.02025Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7.875V4.375H6.125V8.75H9.625V7.875H7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1368_2940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.139e76c32c38c0667e0d73ca3334684f.svg";
export { ForwardRef as ReactComponent };